import { v4 as uuid } from 'uuid';
import { getTranslationsAPI } from "./api";

// import { parse as intlMessageFormatParse } from "intl-messageformat-parser";
// import intl from 'react-intl';

// USE FOR TESTING THE LANGUAGE select macro with tags
// const ins = 'Simply {calapp, select,macChrome {click \"Open <b>Mac</b> Chrome Calendar\" and follow the instructions, to complete your sync.}macSafari {click \"Open <b>Mac Safari </b> Calendar\" and follow the instructions, to complete your sync.}macFirefox {click \"Open Link\" to open your calendar app and follow the instructions, to complete your sync.}macOther {click \"Open Calendar\" to open your calendar app and follow the instructions, to complete your sync.}iosSafari {tap \"Open Calendar\" and follow the instructions, to complete your sync.}iosChrome {tap \"Subscribe\" and follow the instructions, to complete your sync.}iosOther {tap \"Subscribe\" and follow the instructions, to complete your sync.}windowsChrome {click  \"Open Microsoft Outlook\", follow the instructions, and click}windowsFirefox {click \"Open Link\" to open Microsoft Outlook, follow the instructions, and click <b>\"Send/Receive\"</b> to complete your sync.}windowsEdge {click \"Yes\" to open Microsoft Outlook, follow the instructions, and click <b>\"Send/Receive\"</b> to complete your sync.}windowsIe {click \"Allow\" to open Microsoft Outlook, follow the instructions, and click <b>\"Send/Receive\"</b> to complete your sync.}windowsOther {click \"Ok\" to open Microsoft Outlook, follow the instructions, and click <b>\"Send/Receive\"</b> to complete your sync.}other {click \"Ok\", follow the instructions, to complete your sync.}}';

async function getTranslations () {
    
    const env = this.env;
    const appStore = env.appStore;
    const apiKey = appStore.widgetSettings.apikey;
    let locale = appStore.locale;
    if ( appStore.widget?.language && appStore.widget?.language !== 'auto') {
        locale = appStore.widget?.language;
    }
    appStore.locale = locale;
    const res = await getTranslationsAPI({
        apiKey,
        traceId: env.traceId,
        locale,
        store: this,
    });

    /*
    const unparsed = res.data;
    const translations = {};
    for (let i in unparsed) {
        const trans = unparsed[i];
        if (trans.indexOf('{') !== -1  && trans.indexOf('}') !== -1) {
            translations[i] = intlMessageFormatParse(unparsed[i]);
        } else {
            translations[i] = unparsed[i];
        }
    }
    */

    this.translations = res.data;
    this.injectDefaults();
    // this.translations['sync.containers.calendar.proc.instruction'] = ins;

    console.log('');
    console.log('');
    console.log('');
    console.log('getTranslations() Response', this.translations);
    this.observed.translations = uuid();

}



export default getTranslations;